import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ChatPage } from '../pages/ChatPage/ChatPage';
import LoginPage from '../pages/LoginPage/LoginPage';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useState, useEffect } from 'react';
import { Col, Layout, Row, Spin } from 'antd';
import { getUser } from '../apis/apis';
import ForgotPasswordPage from '../pages/ForgotPasswordPage/ForgotPasswordPage';
import AutoLoginPage from '../pages/LoginPage/AutoLoginPage';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                await getUser();
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [auth]);

    if (isAuthenticated === null) {
        return (
            <Layout style={{ height: '100vh' }}>
                <Row justify={'center'} align={'middle'} style={{ height: '100%' }}>
                    <Col>
                        <Spin size="large" />
                    </Col>
                </Row>
            </Layout>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
};

const AppRoutes = () => {

    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
    const auth = getAuth();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                setIsAuthenticated(true);
            } else {
                setIsAuthenticated(false);
            }
        });

        return () => unsubscribe();
    }, [auth]);

    if (isAuthenticated === null) {
        return (
            <Layout style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Spin size="large" />
            </Layout>
        );
    }

    return (
        <Routes>
            <Route path="/"
                element={
                    isAuthenticated ? <Navigate to="/chat" replace /> : <LoginPage />
                }
            />
            <Route
                path="/autologin"
                element={isAuthenticated ? <Navigate to="/chat" replace /> : <AutoLoginPage />}
            />
            <Route
                path='/forgot-password'
                element={
                    <ForgotPasswordPage />
                }
            />
            <Route
                path="/chat"
                element={
                    <ProtectedRoute>
                        <ChatPage />
                    </ProtectedRoute>
                }
            />
        </Routes>
    )
};

export default AppRoutes;
